import React from 'react';
import PropTypes from 'prop-types';

function UnspecifiedButton({ onClick, size = 'large' }) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick();
    }
  };

  const iconSize = size === 'small' ? 'fa-lg' : 'fa-2x';
  const textSize = size === 'small' ? 'fs-6' : 'fs-4';

  return (
    <>
      <div
        className="position-relative d-inline-flex flex-row cursor-pointer mb-2 me-2 align-items-center"
        id="btn_unspecified"
        onClick={onClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex="0"
      >
        <div className="d-inline-block me-2">
          <i className={`fa-solid fa-circle-question ${iconSize}`} />
        </div>
        <span className={textSize}>Unspecified *</span>
      </div>
      <small className="d-flex">
        <em>* Reporters want to quote someone or something</em>
      </small>
    </>
  );
}

UnspecifiedButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['small', 'large']),
};

UnspecifiedButton.defaultProps = {
  size: 'large',
};

export default UnspecifiedButton;
